import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Directive({
  selector: '[vmRemoveFromView]',
  standalone: true,
})
export class RemoveFromViewDirective implements AfterViewInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private el = inject(ElementRef);

  @Input() vmRemoveFromView = false;
  queryParam: {
    embeddedWebApp?: string;
    utm_campaign?: string;
  };

  ngAfterViewInit() {
    setTimeout(() => {
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => {
          if (event.url.includes('?embeddedWebApp=true') || event.url.includes('utm_campaign')) {
            this.queryParam = {
              embeddedWebApp: event.url.includes('?embeddedWebApp=true') ? 'true' : undefined,
              utm_campaign: event.url.includes('utm_campaign') ? event.url.split('utm_campaign=')[1] : undefined,
            };
          }
          this.removeNode();
        });

      this.activatedRoute.queryParams.subscribe((data) => {
        if (data['embeddedWebApp']) {
          this.queryParam = data;
        }
        this.removeNode();
      });
    }, 10);
  }

  removeNode() {
    this.checkParamsForAppContainer();
    const sessionVal = JSON.parse(sessionStorage.getItem('webAppContainerCookies') || '{}');

    if (sessionVal.isContainerInsideApp && this.vmRemoveFromView) {
      this.el.nativeElement.remove();
    }
  }

  private checkParamsForAppContainer() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { embeddedWebApp = '', utm_campaign } = this.queryParam || {};
    const isWebContainerInsideApp = embeddedWebApp.toLowerCase() === 'true';

    if (isWebContainerInsideApp) {
      sessionStorage.setItem(
        'webAppContainerCookies',
        JSON.stringify({
          isContainerInsideApp: isWebContainerInsideApp,
          isDeepLinkForMobileUser: /mobile_cus_app/gi.test(utm_campaign),
          isDeepLinkForCableUser: /cable_cus_app/gi.test(utm_campaign),
          isDeepLinkForLandlineTile: this.activatedRoute?.snapshot?.params?.['uid']?.toLowerCase() === 'landline',
        })
      );
    }
  }
}
